import './AnimatePage.scss';

function AnimatePage() {
   return (
      <div className="animate_page"></div>
   );
}

export default AnimatePage;